import { render, staticRenderFns } from "./NotMobileOptimized.vue?vue&type=template&id=c4174338&scoped=true"
import script from "./NotMobileOptimized.vue?vue&type=script&lang=js"
export * from "./NotMobileOptimized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4174338",
  null
  
)

export default component.exports